import { useMemo } from 'react';
import { useAppSelector } from '../../../app/hooks';
import {
  RanchAreaEnum,
  RanchPageViewEnum,
  selectRanchFocusArea,
  selectRanchPageView,
} from '../ranchesSlice';

const defaultRanchViewArea = `
  '${RanchAreaEnum.mapArea} ${RanchAreaEnum.mapArea}'
`;

const defaultBlockViewArea = `
  '${RanchAreaEnum.mapArea} ${RanchAreaEnum.imageArea}'
  '${RanchAreaEnum.mapArea} ${RanchAreaEnum.chartArea}'
`;

const useRanchLayout = () => {
  const ranchPageView = useAppSelector(selectRanchPageView);
  const focusedArea = useAppSelector(selectRanchFocusArea);

  const gridArea = useMemo(() => {
    if (ranchPageView === RanchPageViewEnum.scansPage) {
      return `'${RanchAreaEnum.scansArea}'`;
    } else if (ranchPageView === RanchPageViewEnum.ranchSummary) {
      if (focusedArea) {
        return `
        '${focusedArea} ${focusedArea}'
        '${focusedArea} ${focusedArea}'
        `;
      } else {
        return defaultRanchViewArea;
      }
    } else if (ranchPageView === RanchPageViewEnum.blockDetail) {
      if (focusedArea) {
        return `
        '${focusedArea} ${focusedArea}'
        '${focusedArea} ${focusedArea}'
         `;
      } else {
        return defaultBlockViewArea;
      }
    }
    return '';
  }, [focusedArea, ranchPageView]);

  const gridTemplateRows = useMemo(() => {
    if (
      ranchPageView === RanchPageViewEnum.ranchSummary ||
      ranchPageView === RanchPageViewEnum.scansPage
    ) {
      return '1fr';
    } else {
      return '1fr 30vh';
    }
  }, [ranchPageView]);

  const gridTemplateColumns = useMemo(() => {
    if (ranchPageView === RanchPageViewEnum.scansPage) {
      return '1fr';
    } else {
      return '3fr 2fr';
    }
  }, [ranchPageView]);

  return { gridArea, gridTemplateRows, gridTemplateColumns };
};

export default useRanchLayout;
